import React from 'react'
import { Link } from 'react-router-dom'
import TestimonialSlider from './TestimonialSlider'

function About() {
  return (
    <div>
    <div className="section-bg section-padding subheader" style={{backgroundImage: 'url(/tm/react/roboto/assets/images/subheader.jpg)' }}>
    	<div className="container">
    		<div className="row">
    			<div className="col-12 text-center">
    				<h1 className="text-white page-title">About Us</h1>
    			</div>
    		</div>
    	</div>
    </div>
    {/* <!-- Subheader End -->
    <!-- About Start --> */}
    <section className="section-padding section">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6">
                    <div className="image mb-xl-30">
                        <img src="/tm/react/roboto/assets/images/about.jpg" alt="img" className="image-fit"/>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="section-header">
                        <p className="section_count"></p>
                        <h3 className="title">the quickest and innovative idea with the innovative intelligence solution Type a message</h3>
                    </div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat</p>
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="icon_box">
                                <i className="flaticon-diagram"></i>
                                <h5 className="title mb-0">All Device<br /> Testing System</h5>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="icon_box">
                                <i className="flaticon-robotic-arm"></i>
                                <h5 className="title mb-0">Robots<br /> Engineering</h5>
                            </div>
                        </div>
                    </div>
                    <Link to="/about" className="thm-btn btn-rounded mb-xl-30">
                        <span className="button_title">Read More</span>
                    </Link>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- About End -->
    <!-- Testimonials Start --> */}
    <TestimonialSlider/>
    {/* <!-- Testimonials End -->
    <!-- Team Start --> */}
    <section className="section-padding section">
        <div className="container">
            <div className="section-header text-center">
                <p className="section_count"></p>
                <h3 className="title">Our Team</h3>
            </div>
            <div className="row">
                <div className="col-lg-3 col-md-6">
                    <div className="team_block">
                        <div className="team_img">
                            <img src="/tm/react/roboto/assets/images/team/1.jpg" alt="img" className="image-fit"/>
                        </div>
                        <div className="team_caption">
                            <h5 className="team_name"><Link to="/team">Bratt Lee</Link></h5>
                            <p className="team_post">Manager</p>
                            <button type="button" className="team_share">
                                <i className="fas fa-share-alt"></i>
                            </button>
                            <ul className="social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-3 col-md-6">
                    <div className="team_block">
                        <div className="team_img">
                            <img src="/tm/react/roboto/assets/images/team/2.jpg" alt="img" className="image-fit"/>
                        </div>
                        <div className="team_caption">
                            <h5 className="team_name"><Link to="/team">Jacks Kallis</Link></h5>
                            <p className="team_post">Manager</p>
                            <button type="button" className="team_share">
                                <i className="fas fa-share-alt"></i>
                            </button>
                            <ul className="social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-3 col-md-6">
                    <div className="team_block">
                        <div className="team_img">
                            <img src="/tm/react/roboto/assets/images/team/3.jpg" alt="img" className="image-fit"/>
                        </div>
                        <div className="team_caption">
                            <h5 className="team_name"><Link to="/teamtml">Jhon Deo</Link></h5>
                            <p className="team_post">Manager</p>
                            <button type="button" className="team_share">
                                <i className="fas fa-share-alt"></i>
                            </button>
                            <ul className="social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-3 col-md-6">
                    <div className="team_block">
                        <div className="team_img">
                            <img src="/tm/react/roboto/assets/images/team/4.jpg" alt="img" className="image-fit"/>
                        </div>
                        <div className="team_caption">
                            <h5 className="team_name"><Link to="/team.ml">Robin Albert</Link></h5>
                            <p className="team_post">Manager</p>
                            <button type="button" className="team_share">
                                <i className="fas fa-share-alt"></i>
                            </button>
                            <ul className="social">
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-facebook-f"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-twitter"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <i className="fab fa-linkedin-in"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    </div>
  )
}

export default About